export const REQUIRED = 'required';
export const ONE_OF = 'oneOf';
export const MAX = 'max';
export const MIN = 'min';
export const TYPE = 'typeError';
export const EMAIL = 'email';

export const CUSTOMER_NUMBER = 'is-kdnr';
export const IBAN = 'is-iban';
export const AREA_CODE = 'is-area-code';
export const ZIP = 'is-zip';
export const MAX_AGE = 'max-age';
export const MIN_AGE = 'min-age';
export const NOT_IN_FUTURE = 'not-in-future';
export const VALID_DATE = 'valid-date';
export const SWITCHING_DATE = 'valid-switching-date';
export const NUMERIC = 'numeric';
export const STARTS_WITH = 'starts-with';
export const NOT_STARTS_WITH = 'not-starts-with';
export const UNIQUE_CLI = 'unique-cli';
export const RFC_EMAIL = 'rfc-email';
